import van, { type ChildDom } from "vanjs-core";
import type { PriceWrapper } from "../billing/prices";
import { locale } from "../locale";
import { div, input, label, option, select } from "./van-tags";

interface SubscriptionFieldParams {
	getPriceId: () => string;
	getPrices: () => Record<string, PriceWrapper>;
	isDisabled: () => boolean;
	setPriceId: (priceId: string) => void;
}

export function subscriptionField(args: SubscriptionFieldParams): ChildDom {
	const priceInfo = van.derive(() =>
		args.getPrices()[args.getPriceId()].toString(),
	);
	return div(
		{ class: "field" },
		label(
			{ class: "label" },
			locale.string({
				enGB: "Subscription",
				deDE: "Abonnement",
				frFR: "Abonnement",
				svSE: "Prenumeration",
			}),
		),
		div(
			{ class: "control" },
			div(
				{ class: "select" },
				select(
					{
						disabled: () => args.isDisabled(),
						onchange: async (e: Event) => {
							if (!(e.target instanceof HTMLSelectElement))
								return;
							args.setPriceId(e.target.value);
						},
					},
					option({
						text: locale.string({
							enGB: "None",
							deDE: "Keines",
							frFR: "Aucun",
							svSE: "Ingen",
						}),
						value: "",
					}),
					...Object.entries(args.getPrices).map(([id, price]) =>
						option({
							value: id,
							text: price.name,
						}),
					),
				),
			),
		),
		div(
			{ class: "control" },
			input({
				class: "input is-static",
				value: priceInfo,
			}),
		),
	);
}
